
export const Roles = [
    { name: 'Администратор', key: 'admin' },
    { name: 'Организатор', key: 'manager' },
    { name: 'Пользователь', key: 'user' },
]


export const isCRMUser = (roles?: string[]) => !!roles?.includes("crm");
export const isCalculationsUser = (roles?: string[]) => !!roles?.includes("calculations");
export const isCRMExportUser = (roles?: string[]) => !!roles?.includes("crm-export");
export const userIsCRMExportUser = (user: any) => !!user?.roles?.includes("crm-export");

